import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["bgcolor"]
const _hoisted_2 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_sheet, {
      class: "d-flex",
      height: "54",
      tile: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_menu, {
          modelValue: _ctx.dialog,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
          "close-on-content-click": false,
          location: "end"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_switch, {
              modelValue: _ctx.isCalendarView,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCalendarView) = $event)),
              label: "Switch",
              color: "secondary"
            }, null, 8, ["modelValue"]),
            (_ctx.isCalendarView)
              ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                  key: 0,
                  icon: ""
                }, props), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-cog")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1040))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, { "min-width": "300" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                  items: _ctx.types,
                  class: "ma-2",
                  label: "View Mode",
                  variant: "outlined",
                  dense: "",
                  "hide-details": ""
                }, null, 8, ["modelValue", "items"]),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.weekday,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.weekday) = $event)),
                  items: _ctx.weekdays,
                  class: "ma-2",
                  label: "weekdays",
                  variant: "outlined",
                  dense: "",
                  "hide-details": ""
                }, null, 8, ["modelValue", "items"]),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialog = false))
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode(" Cancel ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog = false))
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode(" Save ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_sheet, null, {
      default: _withCtx(() => [
        (_ctx.isCalendarView)
          ? (_openBlock(), _createBlock(_component_v_calendar, {
              key: 0,
              ref: "calendar",
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value) = $event)),
              events: _ctx.events,
              "view-mode": _ctx.type,
              weekdays: _ctx.weekday
            }, {
              event: _withCtx(({ day, allDay, event }) => [
                _createVNode(_component_v_menu, {
                  modelValue: event.showMenu,
                  "onUpdate:modelValue": ($event: any) => ((event.showMenu) = $event),
                  "close-on-content-click": false,
                  location: "end"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_chip, _mergeProps({
                      class: "ma-1",
                      color: event.color,
                      label: ""
                    }, props), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: _ctx.getPaymentStatusIcon(event.paymentStatus),
                          start: ""
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(event.slot + "-" + event.title), 1)
                      ]),
                      _: 2
                    }, 1040, ["color"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { "min-width": "300" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              subtitle: event.duration
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_avatar, {
                                  color: event.color,
                                  size: "40"
                                }, null, 8, ["color"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: `/clients/${event.userId}?tab=appointment`
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(event.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1032, ["subtitle"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_actions, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              onClick: ($event: any) => (event.showMenu = false)
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode(" Cancel ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "events", "view-mode", "weekdays"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_menu, {
                    modelValue: _ctx.filtersDialog,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filtersDialog) = $event)),
                    "close-on-content-click": false,
                    location: "end"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("mdi-cog")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { "min-width": "300" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            class: "ma-2",
                            modelValue: _ctx.showPreviousAppointments,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showPreviousAppointments) = $event)),
                            color: "secondary",
                            label: "Show previous appointments",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.appointmentStatus,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.appointmentStatus) = $event)),
                            items: _ctx.appointmentStatuses,
                            class: "ma-2",
                            label: "Appointment status",
                            variant: "outlined",
                            dense: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.paymentStatus,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.paymentStatus) = $event)),
                            items: _ctx.paymentStatuses,
                            class: "ma-2",
                            label: "Payment status",
                            variant: "outlined",
                            dense: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                variant: "flat",
                                color: "primary",
                                onClick: _ctx.onClearFilters
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode(" Clear filters ")
                                ])),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_v_switch, {
                    class: "ma-2",
                    modelValue: _ctx.isExpandAppointments,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isExpandAppointments) = $event)),
                    color: "secondary",
                    label: "Expand appointments",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_data_table, {
                "group-by": _ctx.groupBy,
                headers: _ctx.headers,
                items: _ctx.allAppointments,
                "item-value": "clientName",
                search: _ctx.search
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", {
                    bgcolor: _ctx.getRowColor(item)
                  }, [
                    _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: `/clients/${item.userId}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clientName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.slot), 1),
                    _createElementVNode("td", null, _toDisplayString(item.endTime), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: item.status,
                        "onUpdate:modelValue": [($event: any) => ((item.status) = $event), ($event: any) => (item.changed = true)],
                        items: _ctx.appointmentStatuses,
                        class: "ma-2",
                        variant: "solo",
                        "bg-color": _ctx.getAppointmentStatusColor(item.status),
                        chips: "",
                        dense: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "bg-color"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: item.paymentStatus,
                        "onUpdate:modelValue": [($event: any) => ((item.paymentStatus) = $event), ($event: any) => (item.changed = true)],
                        items: _ctx.paymentStatuses,
                        class: "ma-2",
                        variant: "solo",
                        "bg-color": _ctx.getPaymentStatusColor(item.paymentStatus),
                        chips: "",
                        dense: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "bg-color"])
                    ]),
                    _createElementVNode("td", null, [
                      (item.changed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            disabled: _ctx.loading,
                            loading: _ctx.loading,
                            density: "default",
                            variant: "flat",
                            color: "secondary",
                            onClick: ($event: any) => (_ctx.onUpdate(item))
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Update ")
                            ])),
                            _: 2
                          }, 1032, ["disabled", "loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1)),
                    _createElementVNode("td", null, [
                      (item.rating > 0)
                        ? (_openBlock(), _createBlock(_component_v_menu, {
                            key: 0,
                            modelValue: item.isFeedbackOpen,
                            "onUpdate:modelValue": ($event: any) => ((item.isFeedbackOpen) = $event),
                            "close-on-content-click": false
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps(props, { variant: "text" }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_rating, {
                                    modelValue: item.rating,
                                    "onUpdate:modelValue": ($event: any) => ((item.rating) = $event),
                                    size: 20,
                                    readonly: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, { style: {"max-width":"400px"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.feedback), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_1)
                ]),
                "no-data": _withCtx(() => _cache[21] || (_cache[21] = [
                  _createElementVNode("div", { class: "custom-no-data" }, " No appointments found. Change filter. ", -1)
                ])),
                "group-header": _withCtx(({ item, columns, toggleGroup, isGroupOpen }) => [
                  _createElementVNode("template", {
                    ref: (el)=>{
                        if (!isGroupOpen(item) && _ctx.isExpandAppointments)
                            toggleGroup(item);
                        }
                  }, null, 512),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: columns.length
                    }, [
                      (!_ctx.isExpandAppointments)
                        ? (_openBlock(), _createBlock(_component_VBtn, {
                            key: 0,
                            icon: isGroupOpen(item) ? '$expand' : '$next',
                            size: "small",
                            variant: "text",
                            onClick: ($event: any) => (toggleGroup(item))
                          }, null, 8, ["icon", "onClick"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.value), 1)
                    ], 8, _hoisted_2)
                  ])
                ]),
                _: 1
              }, 8, ["group-by", "headers", "items", "search"])
            ], 64))
      ]),
      _: 1
    })
  ]))
}